module.exports = __webpack_public_path__ + "img/closed.73391845.webp";